import(/* webpackMode: "eager" */ "/usr/src/app/frontend/src/app/(editor)/s/[noteId]/page.tsx");
